<template>
  <div class="ag-notification">
    <AGAlert
      v-if="!hasDetails"
      :closable="closable"
      :link-text="linkText"
      :loading="loading"
      :message="message"
      :type="type"
      @click:close="emitClickClose"
      @click:link="emitClickLink"
    />

    <AGAlert
      v-else
      :closable="closable"
      :link-text="linkText"
      :loading="loading"
      :message="message"
      :type="type"
      @click:close="emitClickClose"
      @click:link="emitClickLink"
    >
      {{ details }}
    </AGAlert>
  </div>
</template>

<script>
import AGAlert from '@/components/common/AGAlert.vue';

export default {
  components: { AGAlert },

  emits: ['click:close', 'click:link'],

  props: {
    id: {
      type: String,
      required: true,
    },

    message: {
      type: String,
      required: true,
    },

    details: {
      type: [String, undefined],
      default: undefined,
    },

    type: {
      type: String,
      default: 'default',
      validator: (val) => ['info', 'success', 'warning', 'error', 'default'].includes(val),
    },

    closable: {
      type: Boolean,
      default: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    timeout: {
      type: Number,
      default: 5000,
    },

    linkText: {
      type: String,
      required: false,
    },
  },

  computed: {
    hasDetails() {
      return this.details !== undefined;
    },
  },

  mounted() {
    if (this.timeout) setTimeout(() => this.emitClickClose(), this.timeout);
  },

  methods: {
    emitClickClose(e) {
      this.$emit('click:close', e);
    },

    emitClickLink(e) {
      this.$emit('click:link', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-notification {
  pointer-events: auto;
}
</style>
